import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Aside from "../../components/Aside";
import Api from "../../services/api";
import swal from "sweetalert";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import EditGuia from "./edit";
import NewGuia from "./new";
import EditConteudo from "./editconteudo";
import ReactTooltip from "react-tooltip";

export default function Guias() {
  const [loading, setLoading] = useState(true);
  const Loader = () => <div className="loading"></div>;
  const [guias, setGuias] = useState([]);
  const [openModalNew, setOpenModalNew] = useState(false);
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const [guiaEdit, setGuiaEdit] = useState([]);
  const [openModalEditConteudo, setOpenModalEditConteudo] = useState(false);
  const [guiaEditConteudo, setGuiaEditConteudo] = useState([]);

  useEffect(() => {
    loadGuias();
  }, []);

  function loadGuias() {
    Api.get("/guias/list?all=1")
      .then((response) => {
        setGuias(response.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("ops! ocorreu um erro" + err);
      });
  }

  function editGuia(guia) {
    setGuiaEdit(guia);
    setOpenModalEdit(true);
  }

  function editConteudo(guia) {
    setGuiaEditConteudo(guia);
    setOpenModalEditConteudo(true);
  }

  function deleteGuia(guia) {
    swal({
      title: "Excluir Guia",
      text: "Deseja realmente excluir o guia '" + guia.nome_pt + "' ?",
      icon: "warning",
      html: true,
      buttons: ["Cancelar", "Excluir"],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        setLoading(true);
        Api.delete("/guias/delete/" + guia.id)
          .then((response) => {
            swal(response.data.message, { icon: "success" });
            loadGuias();
            setLoading(false);
          })
          .catch((err) => {
            swal("ops! ocorreu um erro" + err, { icon: "success" });
            setLoading(false);
          });
      }
    });
  }

  function alteraAtivado(id, ativado) {
    setLoading(true);
    Api.get(`/guias/ativado/${id}/${ativado}`)
      .then(() => {
        loadGuias();
        setLoading(false);
      })
      .catch((err) => console.error("ops! ocorreu um erro" + err));
  }

  const RenderContent = () => {
    useEffect(() => {
      ReactTooltip.rebuild();
    });

    const rows = guias.map((guia, index) => {
      const ativado = () =>
        guia.ativado ? (
          <a
            href="#"
            className="ativado"
            onClick={() => alteraAtivado(guia.id, 0)}
            data-tip="Clique para desativar"
          ></a>
        ) : (
          <a
            href="#"
            className="desativado"
            onClick={() => alteraAtivado(guia.id, 1)}
            data-tip="Clique para ativar"
          ></a>
        );

      return (
        <div className="item" key={index}>
          <div>
            <a
              href="#"
              onClick={() => editGuia(guia)}
              alt="Editar"
              data-tip="Editar"
            >
              <i className="bx bx-edit"></i>
            </a>
            <a
              href="#"
              onClick={() => editConteudo(guia)}
              alt="Conteúdo"
              data-tip="Conteúdo"
            >
              <i className="bx bx-file"></i>
            </a>
            <Link to={"/guias/" + guia.id + "/fotos"} data-tip="Galeria">
              <i className="bx bx-photo-album"></i>
            </Link>
            <a href="#" onClick={() => deleteGuia(guia)} data-tip="Excluir">
              <i className="bx bx-trash"></i>
            </a>
            {ativado()}
          </div>
          <div>
            {guia.imagem && (
              <img
                src={process.env.REACT_APP_FILES_URL + guia.imagem}
                style={{ height: "60px" }}
                alt=""
              />
            )}
          </div>
          <div>{guia.nome_pt}</div>
          <div>{guia.catnome_pt || "-"}</div>
          <div>{guia.data_publicacao_br || "-"}</div>
        </div>
      );
    });

    return (
      <div className="grid">
        <div className="header">
          <div></div>
          <div>Imagem</div>
          <div>Título</div>
          <div>Categoria</div>
          <div>Data</div>
        </div>
        <div className="content">{rows}</div>
      </div>
    );
  };

  function renderTopPage() {
    return (
      <div className="top">
        <div>
          <span className="text">Guia de Experiências</span>
          <ul className="breadcrumbs">
            <li>Guia de Experiências</li>
            <li>Listagem</li>
          </ul>
        </div>
        <div>
          <div className="actions top">
            <Link to="#" onClick={() => setOpenModalNew(true)}>
              <i className="bx bx-plus-circle"></i> Novo Guia
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      {loading ? <Loader /> : null}
      <ReactTooltip effect="solid" />
      <div className="container-box">
        <Aside />
        <main>
          {renderTopPage()}
          {guias && RenderContent()}
        </main>

        <Modal
          open={openModalNew}
          onClose={() => setOpenModalNew(false)}
          classNames={{ overlay: "customOverlay", modal: "customModal50" }}
        >
          <NewGuia loadGuias={loadGuias} setOpenModalNew={setOpenModalNew} />
        </Modal>

        <Modal
          open={openModalEdit}
          onClose={() => setOpenModalEdit(false)}
          classNames={{ overlay: "customOverlay", modal: "customModal50" }}
        >
          <EditGuia
            data={guiaEdit}
            loadGuias={loadGuias}
            setOpenModalEdit={setOpenModalEdit}
          />
        </Modal>

        <Modal
          open={openModalEditConteudo}
          onClose={() => setOpenModalEditConteudo(false)}
          classNames={{ overlay: "customOverlay", modal: "customModal50" }}
        >
          <EditConteudo
            data={guiaEditConteudo}
            loadGuias={loadGuias}
            setOpenModalEditConteudo={setOpenModalEditConteudo}
          />
        </Modal>
      </div>
    </>
  );
}
